// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__23jTn","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3hIQN"};